import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import GeneralButtonsChoiceSegmentButton from 'lumen/components/general/buttons/choice-segment-button';

export interface PreferredRateOnboardingOption {
  icon?: IconName;
  id: string;
  isChecked: boolean;
  label: string;
}

interface HotelWizardsPreferredRateOnboardingPreferredRateOnboardingOptionsSignature {
  Args: {
    options: PreferredRateOnboardingOption[];
    updateOption: (option: PreferredRateOnboardingOption) => void;
  };
  Blocks: {
    default: [];
  };
}

const HotelWizardsPreferredRateOnboardingPreferredRateOnboardingOptions =
  <template>
    <div class="wizards-preferred-rate-onboarding__options">
      {{#each @options as |option|}}
        <GeneralButtonsChoiceSegmentButton
          @icon={{option.icon}}
          @isChecked={{option.isChecked}}
          @label={{option.label}}
          @onClick={{fn @updateOption option}}
          @type="radio"
        />
      {{/each}}
    </div>
  </template> satisfies TOC<HotelWizardsPreferredRateOnboardingPreferredRateOnboardingOptionsSignature>;

export default HotelWizardsPreferredRateOnboardingPreferredRateOnboardingOptions;
